// extracted by mini-css-extract-plugin
module.exports = {"root":"az_Kkb","text":"az_Lkb","pulse":"az_Mkb","wave":"az_Nkb"};